var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "598DC1AB-F77D-444D-80EF-B6CA7AEE42A2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.875665,3.97699507 L6.875665,15.5738457 C6.875665,15.7384086 6.74354115,15.8754204 6.58055811,15.8754204 L5.17077189,15.8754204 C5.00689059,15.8754204 4.875665,15.7404008 4.875665,15.5738457 L4.875665,3.97699507 C4.875665,3.81243208 4.77966797,3.77141739 4.66124964,3.88983572 L1.49008036,7.061005 C1.36465426,7.1864311 1.17772729,7.17748265 1.056915,7.05667036 L0.0944149996,6.09417036 C-0.0324770902,5.96727827 -0.0287284636,5.77981382 0.0892081762,5.66187718 L5.66212182,0.088963536 C5.78141933,-0.0303339685 5.97127154,-0.0289731039 6.08920818,0.088963536 L11.6621218,5.66187718 C11.7814193,5.78117469 11.7777273,5.97335807 11.656915,6.09417036 L10.694415,7.05667036 C10.5675229,7.18356245 10.379668,7.17942333 10.2612496,7.061005 L7.09008036,3.88983572 C6.96465426,3.76440962 6.875665,3.81043995 6.875665,3.97699507 Z M15.875665,11.8984253 C15.875665,12.0649804 15.9646543,12.1110107 16.0900804,11.9855846 L19.2612496,8.81441536 C19.379668,8.69599703 19.5675229,8.69185791 19.694415,8.81875 L20.656915,9.78125 C20.7777273,9.90206229 20.7814193,10.0942457 20.6621218,10.2135432 L15.0892082,15.7864568 C14.9712715,15.9043935 14.7814193,15.9057543 14.6621218,15.7864568 L9.08920818,10.2135432 C8.97127154,10.0956065 8.96752291,9.90814209 9.094415,9.78125 L10.056915,8.81875 C10.1777273,8.69793771 10.3646543,8.68898926 10.4900804,8.81441536 L13.6612496,11.9855846 C13.779668,12.104003 13.875665,12.0629883 13.875665,11.8984253 L13.875665,0.301574707 C13.875665,0.135019595 14.0068906,-3.55271368e-14 14.1707719,-3.55271368e-14 L15.5805581,-3.55271368e-14 C15.7435411,-3.55271368e-14 15.875665,0.137011719 15.875665,0.301574707 L15.875665,11.8984253 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "portfolio-builder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.3d-account-added",
    transform: "translate(-1401.000000, -118.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "modal",
    transform: "translate(1040.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tabs",
    transform: "translate(1.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "actions",
    transform: "translate(304.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sort",
    transform: "translate(56.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/sort"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(2.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "ic_sort",
    fill: "#8A8888",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Color",
    mask: "url(#mask-2)",
    fill: "#255EBA"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.000000, -4.000000)",
    id: "color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSort);
export default __webpack_public_path__ + "static/media/ic_sort.7b4d148f501d587ca9a12e88d6103408.svg";
export { ForwardRef as ReactComponent };